import React, { Fragment, useEffect } from "react";
import { useFormikContext } from "formik";
import { Col, Row } from "react-bootstrap";
import { CaseFormField } from "../../CaseGenerator";
import ContractsSelect from "../../../common/ContractsSelect/ContractsSelect";
import { useSelector } from "react-redux";
import * as _ from "lodash";
import { useTranslation } from "react-i18next";

const CustomLetturaSicuraStep = (props) => {
  /* eslint-disable */
  const { list: ContractList , current } = useSelector((state) => {
    if (!state.contracts.current) {
      return state.contracts;
    }
    const current = state.contracts.current;
    const selected = _.head(
      state.contracts.list.filter((r) => {
        return r.id === current.id;
      }) 
    );
    return {
      list: state.contracts.list,
      current: selected,
    };
  });

  const { layout, fields } = props;
  const { fields: layoutFields } = layout;
  const { values, setFieldValue } = useFormikContext();
  const { t } = useTranslation();
  useEffect(() => {
    setFieldValue("contractId", current ? current.id : "");
  }, [current, setFieldValue]);
  const isConditionMet = (conditionProps) => {
    if (!conditionProps) {
      return true;
    }
    const conditions = conditionProps;
    if (conditions.length === 0) {
      return true;
    }
    let allowed = false;
    conditions.forEach((condition) => {
      if (values[condition.if] === condition.is) {
        allowed = true;
      }
    });
    return allowed;
  };

  return (
    <Fragment key={layout.title}>
      {!layout.noMandatoryLegend && (
        <p className={"case-step-mandatory-fields-legend paragraph-small-fs9"}>{t("mandatory.fields.legend")}</p>
      )}
      <h2 className="case-step-title">{layout.title}</h2>

      <Row>
        {layoutFields &&
          layoutFields.map((item, index) => {
            const gridProps = item.grid;
            const conditionProps = item.condition || null;
            const fieldProps = fields[item.fieldName];
            const conditionMet = isConditionMet(conditionProps);
            return (
              conditionMet && (
                <Col {...gridProps} key={index}>
                  {!item.fieldName && (
                    <h3 className="form-section-title">{item.text}</h3>
                  )}
                  {item.fieldName && <CaseFormField {...fieldProps} />}
                </Col>
              )
            );
          })}
      </Row>
      <Row style={{ marginTop: "12px" }}>
        <Col xs={12} md={8}>
            <ContractsSelect label={t("cases.lettura_sicura.disattiva.codiceContratto.label")}
            />
        </Col>
        {layout.content && (
          <div className="col-12">
            <div className={"content"}>{layout.content}</div>
          </div>
        )}
      </Row>
    </Fragment>
  );
};
export default CustomLetturaSicuraStep;
